import { AfterViewInit, Component } from "@angular/core";
import {
  faArrowCircleLeft,
  faArrowCircleRight,
} from "@fortawesome/free-solid-svg-icons";
import { Title } from "@angular/platform-browser";
import * as dayjs from "dayjs";
import {
  ActivatedRoute,
  Router,
  NavigationEnd,
  NavigationStart,
} from "@angular/router";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "./store/state/app.state";
import { AppService } from "src/app/app.service";
import { PageParams } from "./store/models/navigation-settings.model";
import { SetPageParams } from "./store/actions/navigation-settings.actions";
import { SetIndividualFlag } from "./store/actions/global.actions";
import { SetGlobalSettingModalVisibility } from "src/app/store/actions/global-user-settings.actions";
import "dayjs/locale/es";
import {
  VAIconRegistryService,
  arrowCircleLeft,
  arrowCircleRight,
} from "@va/core-library/icons";

declare var $: any; // eslint-disable-line
declare function saveExtraPanelSetting(): any;
declare function resizegridOnWindowResize(): any;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements AfterViewInit {
  title = "";
  currentTimeFRLocale: string;
  isOpenInExcelAddin = false;
  isCollapsed = false;
  faArrowCircleLeft = faArrowCircleLeft;
  faArrowCircleRight = faArrowCircleRight;
  showLeftSidebar = true;
  disabledSidebar = false;
  fBarPages: Array<string> = [
    "comps",
    "revisions",
    "surprise",
    "mex",
    "valuation",
    "tpr",
    "industry_metrics",
  ];
  noSecHeader: Array<string> = ["home", "search-page"];
  contentSectionHeight = "";
  showReturnToHomeLink: Array<string> = ["mex", "surprise", "revisions"];
  pageName = "";
  showRightSidebar = false;
  showPrimaryHeader = true;
  showSecondaryHeader = true;
  showFooter = true;
  isRightsideBarCollapsed = true;
  isVisibleEteModal = false;
  public constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private titleService: Title,
    private store: Store<AppState>,
    private appService: AppService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([arrowCircleLeft, arrowCircleRight]);
    router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.actionsAtStartOfNavigation(event.url);
      }
      if (event instanceof NavigationEnd) {
        this.pushPageParamsToStore(event.url);
        this.title = this.getTitle(
          router.routerState,
          router.routerState.root,
        ).join("-");
        titleService.setTitle(this.title);
      }
    });
  }

  getTitle(state, parent) {
    const data = [];
    if (parent && parent.snapshot.data && parent.snapshot.data.title) {
      data.push(parent.snapshot.data.title);
    }

    if (state && parent) {
      data.push(...this.getTitle(state, state.firstChild(parent)));
    }

    return data;
  }

  actionsAtStartOfNavigation(url: string) {
    if (url.includes("exceladdin")) {
      this.appOpenedInExcelAddin();
    }
  }

  pushPageParamsToStore(url: string) {
    const urlParts = url.split("?")[0].split("/").slice(1); // adding split("?") to remove query params here
    const payload: PageParams = { pageName: "" };
    let urlStructure: string[] = [];
    //debouncedBlock(urlParts.includes("mex"));
    if (urlParts.includes("mex")) {
      urlStructure = ["pageName", "ticker", "cut", "pg", "source"];
      // } else if (urlParts.includes("mex") && !urlParts.includes("SAR")) {
      //   urlStructure = ["pageName", "ticker", "cut", "pg"];
    } else if (urlParts.includes("company")) {
      if (urlParts.includes("revisions")) {
        urlParts.shift();
        urlParts.reverse();
        // handling to suport bloomberg ticker
        urlStructure =
          urlParts.length === 2
            ? ["pageName", "ticker"]
            : ["tickerType", "pageName", "ticker"];
      } else if (urlParts.includes("surprise")) {
        urlParts.shift();
        urlParts.reverse();
        urlStructure = ["pageName", "ticker"];
      } else if (urlParts.includes("events")) {
        urlStructure = ["parentPage", "ticker", "pageName"];
      } else {
        urlStructure = ["pageName", "ticker"];
      }
    } else if (urlParts.includes("research")) {
      urlStructure = ["pageName", "ticker", "companySymbologyId"];
    } else {
      urlStructure = ["pageName"];
    }
    urlStructure.forEach((part: string, index: number) => {
      payload[part] = urlParts[index];
    });
    this.store.dispatch(new SetPageParams(payload));
  }

  ngAfterViewInit() {
    this.setBlockUIConsts();
  }

  ngOnInit(): void {
    dayjs.locale("en");
    this.currentTimeFRLocale = dayjs().format("LLL");

    this.store
      .select(stateGetter("globalHeader", "globalSettings"))
      .subscribe((data) => {
        if (data.showNavFB) {
          this.fBarPages.push("nav");
        }
      });

    this.store
      .select(stateGetter("leftPanel", "isCollapsed"))
      .subscribe((isCollapsed: any) => {
        this.isCollapsed = isCollapsed;
        setTimeout(function () {
          window.dispatchEvent(new Event("resize"));
        }, 300);
      });
    this.store
      .select(stateGetter("leftPanel", "display"))
      .subscribe((display: any) => {
        this.showLeftSidebar = display;
      });
    this.store
      .select(stateGetter("leftPanel", "disabled"))
      .subscribe((disabled: any) => {
        this.disabledSidebar = disabled;
      });

    this.store
      .select(stateGetter("globalSubheader", "pageName"))
      .subscribe((pageName: any) => {
        this.pageName = pageName;
        this.contentSectionHeight =
          this.pageName === "industry_metrics"
            ? "calc(100vh - 145px - 28px)"
            : "";
      });

    this.store
      .select(stateGetter("rightPanel", "display"))
      .subscribe((display: any) => {
        this.showRightSidebar = display;
      });

    this.store
      .select(
        stateGetter("globalUserSettings", "modalSettings", "isVisibleEteModal"),
      )
      .subscribe((isVisibleEteModal: any) => {
        this.isVisibleEteModal = isVisibleEteModal;
      });
  }

  appOpenedInExcelAddin(): void {
    this.isOpenInExcelAddin = true;
    this.store.dispatch(
      new SetIndividualFlag({ key: "enableUsersnap", value: false }),
    );
    this.store.dispatch(
      new SetIndividualFlag({ key: "enablePendo", value: false }),
    );
    this.showPrimaryHeader = false;
    this.showSecondaryHeader = false;
    this.showRightSidebar = false;
    this.showLeftSidebar = false;
    this.showFooter = false;
    setTimeout(() => {
      if (window.Usersnap) {
        window.Usersnap.destroy();
      }
    }, 1500);
  }

  leftSiderChanged(e) {
    const locArray = this.router.url.split("/");
    let company = "";
    let event = "";
    let feature = "";
    if (locArray[locArray.length - 2] === "company") {
      company = locArray[locArray.length - 1];
      if (e) {
        feature = "LEFT_PANEL_COLLAPSE";
        event = "LEFT_PANEL_COLLAPSE";
      } else {
        feature = "LEFT_PANEL_EXPAND";
        event = "LEFT_PANEL_EXPAND";
      }
    }

    const isIEOrEdge = /msie\s|trident\//i.test(window.navigator.userAgent);
    if (isIEOrEdge) {
      setTimeout(() => {
        const evt = document.createEvent("UIEvents");
        evt.initEvent("resize", true, false);
        window.dispatchEvent(evt);
      }, 400);
      if (locArray[locArray.length - 2] === "company") {
        this.appService.logUserAction(
          event,
          company,
          "",
          feature,
          { company: company },
          "",
          "LEFT_PANEL_CLICK",
        ); //cut
      }
      return;
    }
    setTimeout(() => window.dispatchEvent(new Event("resize")), 400);
    if (locArray[locArray.length - 2] === "company") {
      this.appService.logUserAction(
        event,
        company,
        "",
        feature,
        { company: company },
        "",
        "LEFT_PANEL_CLICK",
      ); //cut
    }
    if (this.pageName === "mex") {
      if (e) {
        feature = "LEFT_PANEL_COLLAPSE";
        event = "LEFT_PANEL_COLLAPSE";
      } else {
        feature = "LEFT_PANEL_EXPAND";
        event = "LEFT_PANEL_EXPAND";
      }
      this.appService.logUserAction(
        event,
        locArray[locArray.length - 3],
        window.MEData.view_code,
        feature,
        { company: locArray[locArray.length - 3] },
        window.MEData.view_code === "SAR" ? locArray[locArray.length - 1] : "",
        "LEFT_PANEL_CLICK",
      );
      setTimeout(() => {
        saveExtraPanelSetting();
        resizegridOnWindowResize();
      }, 100);
    }
  }

  setBlockUIConsts = () => {
    $.blockUI.defaults.css.width = "0px";
    $.blockUI.defaults.css.border = "0px solid #696463";
    $.blockUI.defaults.css.background = "#FFFFFF";
    $.blockUI.defaults.message = `<div class="loader_clear_all_box"><img class="loader_image_clear_all" src="${window.assetUrl}/spinner-blue.gif"/></div>`;
    $.blockUI.defaults.overlayCSS.cursor = "default";
    $.blockUI.defaults.overlayCSS.opacity = 0.6;
  };

  onCloseEteModal() {
    this.store.dispatch(new SetGlobalSettingModalVisibility(false));
  }
}
